// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_PayDespesaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/pay_despesa/{despesa_id}
 *
 * Validates input for marking a despesa as paid.
 */
import { registerContract } from './validate'

export interface Payroll_PayDespesaInput {
franchise_id: number
payment_date: string
comprovante_url?: string
}

registerContract('Payroll_PayDespesaInput', {
  franchise_id:    { type: 'number',  required: true },
  payment_date:    { type: 'string',  required: true },
  comprovante_url: { type: 'string',  required: false },
})
